<div
  class="text-mobileMd tablet:text-tabletMd desktop:text-desktopMd z-50 flex justify-center items-center m-4"
>
  <div class="bg-white w-[347px]">
    <ng-container>
      <sc-radio-button-list formControlName="items">
        @for (locale of localeList$ | async; track $index; let last = $last) {
          <div class="py-2 text-sm">
            <sc-radio-button
                [radioOption]="{
                value: locale.code,
                label: locale.name | scRemoveTermShorthand,
                isSelected: currentLocale === locale.code,
              }"
              [isOutlined]="false"
              (retrieveValue)="selectLanguage($event.toString())"
            ></sc-radio-button>
          </div>
          <div class="horizontal-divider" [ngClass]="{ hidden: last }"></div>
        }
      </sc-radio-button-list>
    </ng-container>
  </div>
</div>
